import { Entity, Thread } from '../types';

export enum MessageBodyCollapsingLayoutType {
  CollapsedPinned = 'CollapsedPinned',
  Collapsed = 'Collapsed',
  Expanded = 'Expanded',
}

export enum AttachmentsCollapsingLayoutType {
  Collapsed = 'Collapsed',
  PartlyCollapsed = 'PartlyCollapsed',
  Expanded = 'Expanded',
}

export enum ReplyCollapsingLayoutType {
  Collapsed = 'Collapsed',
  Expanded = 'Expanded',
}

export interface ThreadLayout extends Entity {
  readonly threadStarterBody: MessageBodyCollapsingLayoutType;
  readonly threadStarterAttachments: AttachmentsCollapsingLayoutType;
  readonly replies: ReplyCollapsingLayoutType;
}

export type ThreadLayouts = Record<Thread['id'], ThreadLayout>;
